import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Link/style";
import _Link from "@arco-design/web-react/es/Link";
import "@arco-design/web-react/es/Checkbox/style";
import _Checkbox from "@arco-design/web-react/es/Checkbox";
import _IconLock from "@arco-design/web-react/icon/react-icon/IconLock";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import _IconUser from "@arco-design/web-react/icon/react-icon/IconUser";
import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import useStorage from '@/utils/useStorage';
import useLocale from '@/utils/useLocale';
import locale from './locale';
import styles from './style/index.module.less';
export default function LoginForm() {
  const formRef = useRef();
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [loginParams, setLoginParams, removeLoginParams] = useStorage('loginParams');
  const t = useLocale(locale);
  const [rememberPassword, setRememberPassword] = useState(!!loginParams);
  function afterLoginSuccess(params) {
    // 记住密码
    if (rememberPassword) {
      setLoginParams(JSON.stringify(params));
    } else {
      removeLoginParams();
    }
    // 记录登录状态
    localStorage.setItem('userStatus', 'login');
    // 跳转首页
    window.location.href = '/';
  }

  // function login(params) {
  //   setErrorMessage('');
  //   setLoading(true);
  //   axios
  //     .post('/api/user/login', params)
  //     .then((res) => {
  //       const { status, msg } = res.data;
  //       if (status === 'ok') {
  //         afterLoginSuccess(params);
  //       } else {
  //         setErrorMessage(msg || t['login.form.login.errMsg']);
  //       }
  //     })
  //     .finally(() => {
  //       setLoading(false);
  //     });
  // }

  function login(params) {
    setErrorMessage('');
    setLoading(true);
    axios.post('https://ads.i-gcash.com/api/user/login', params).then(res => {
      const {
        status,
        msg,
        token
      } = res.data;
      if (status === 'ok') {
        localStorage.setItem('Access-Token', token);
        if (res.data.action == 'index') {
          localStorage.setItem('userStatus', 'login');
          window.location.hash = 'live';
        }
      } else {
        setErrorMessage(msg || t['login.form.login.errMsg']);
      }
    }).finally(() => {
      setLoading(false);
    });
  }
  function onSubmitClick() {
    formRef.current.validate().then(values => {
      login(values);
    });
  }

  // 读取 localStorage，设置初始值
  useEffect(() => {
    const rememberPassword = !!loginParams;
    setRememberPassword(rememberPassword);
    if (formRef.current && rememberPassword) {
      const parseParams = JSON.parse(loginParams);
      formRef.current.setFieldsValue(parseParams);
    }
  }, [loginParams]);
  return /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-title']
  }, t['login.form.title']), /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-sub-title']
  }, t['login.form.title']), /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-error-msg']
  }, errorMessage), /*#__PURE__*/React.createElement(_Form, {
    className: styles['login-form'],
    layout: "vertical",
    ref: formRef,
    initialValues: {
      username: 'admin',
      password: 'admin'
    }
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "username",
    rules: [{
      required: true,
      message: t['login.form.username.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    prefix: /*#__PURE__*/React.createElement(_IconUser, null),
    placeholder: t['login.form.username.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "password",
    rules: [{
      required: true,
      message: t['login.form.password.errMsg']
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    prefix: /*#__PURE__*/React.createElement(_IconLock, null),
    placeholder: t['login.form.password.placeholder'],
    onPressEnter: onSubmitClick
  })), /*#__PURE__*/React.createElement(_Space, {
    size: 16,
    direction: "vertical"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-password-actions']
  }, /*#__PURE__*/React.createElement(_Checkbox, {
    checked: rememberPassword,
    onChange: setRememberPassword
  }, t['login.form.rememberPassword']), /*#__PURE__*/React.createElement(_Link, null, t['login.form.forgetPassword'])), /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    long: true,
    onClick: onSubmitClick,
    loading: loading
  }, t['login.form.login']), /*#__PURE__*/React.createElement(_Button, {
    type: "text",
    long: true,
    className: styles['login-form-register-btn']
  }, t['login.form.register']))));
}